import { MinimalConversation } from "@redotech/redo-model/conversation";
import { CardListRef } from "@redotech/redo-web/card-list";
import { TableRef } from "@redotech/redo-web/table";
import { createContext } from "react";

export interface UpdateConversationStateContext {
  tableRef: React.MutableRefObject<TableRef<MinimalConversation>>;
  cardListRef: React.MutableRefObject<CardListRef<MinimalConversation>>;
  invalidateCache: () => void;
  waitForRefresh: () => Promise<void>;
  refreshIgnoreResult: () => void;
  removeConversation: (conversation: MinimalConversation) => void;
  optimisticUpdate: (conversation: MinimalConversation) => void;
}

export const UpdateConversationStateContext = createContext<
  UpdateConversationStateContext | undefined
>(undefined);
